/*
  Screen size breakpoints for responsive design
  
  xs = 0px - 373px
  sm = 375px - 599px
  md = 600px - 839px
  lg = 840px - 1023px
  xl = 1024px - 1183px
  xxl = 1184px - XXXXpx
*/

export const BREAKPOINTS = {
  xs: {
    min: 0,
    max: 373
  },
  sm: {
    min: 375,
    max: 599
  },
  md: {
    min: 600,
    max: 839
  },
  lg: {
    min: 840,
    max: 1023
  },
  xl: {
    min: 1024,
    max: 1183
  },
  xxl: {
    min: 1184,
    max: Infinity
  }
};

export const MEDIA_QUERIES = {
  isMobile: `(max-width: ${BREAKPOINTS.lg.max}px)`,
  isDesktop: `(min-width: ${BREAKPOINTS.lg.max + 1}px)`
};

export default BREAKPOINTS;
